export const  esES: { [key: string]: any } = {
    'layout.menu.link.report': "Reportes",

    'report.container.breadcrumb.item.resources':'Signal',
    'report.container.drawer.title': "Resources",

    'header.span.welcome':'Bienvenido',
    'profile.button.logout': "Cerrar Sesión",

    'exception.message.404.title':'Página No Encontrada',
    'exception.message.404.subtitle':'Lo siento, la página que buscas no existe en este sitio',
    'exception.message.400.title':'Solicitud Incorrecta',
    'exception.message.400.subtitle':'El navegador envió una petición que el servidor no pudo entender',
    'exception.message.403.title':'Acceso Denegado',
    'exception.message.403.subtitle':'Lo siento, no está autorizado para acceder a esta página',
    'exception.message.500.title':'Error Interno del Servidor',
    'exception.message.500.subtitle':'Algo ocurrió en nuestros sistemas. Por favor intenta de nuevo y si el problema persiste comunicate con nosotros con el siguiente número de ticket',
    'exception.message.default.thank':'Gracias',
    
    'share.link.copy.message':'Link copiado en el portapapeles!',

    'empty.description':'No se encontro información asociada al usuario.',
    'report.container.pages.drawer.title': 'Páginas del reporte',

    'dataset.container.table.name':'Nombre',
    'dataset.container.table.size':'Tamaño',
    'dataset.container.table.createdOn':'Fecha de Creación',
    'dataset.container.table.lastModified':'Fecha de Actualización',

    'dataset.container.input.search':'Introduzca su texto aquí',
    'dataset.container.button.loadmore':'Ver más',
};